module.exports = __webpack_public_path__ + "img/step5.a5137b57.png";